import React from "react";
import Customers from "./Customers";
import Operatives from "./Operatives";
import Rates from "./Rates";
import RatesForm from "./RatesForm";
import CustomersForm from "./CustomersForm";
// import SettingsForm from "./SettingsForm";
import { Route, Switch } from "react-router-dom";
import OperativesForm from "./OperativesForm";
import GeneralSettings from "./GeneralSettings";
// import Footer from "./Footer";
import LinkedAccounts from "./LinkedAccounts";
import ExportWrapper from "./ExportWrapper";
import BusinessInfo from "./BusinessInfo";
import AIFeaturesSettings from "./AIFeaturesSettings";
import TemplatesSettings from "./TemplatesSettings";

const Settings = () => {
  return (
    <div>
      {/* <h3>Settings</h3> */}
      {/* <Link to="/settings/rates">Rates</Link>
      <Link to="/settings/operatives">Operatives</Link>
      <Link to="/settings/customers">Customers</Link>
      <Link to="/settings">General</Link> */}

      <Switch>
        <Route path="/settings/rates/:uid">
          <RatesForm />
        </Route>
        <Route path="/settings/operatives/:uid">
          <OperativesForm />
        </Route>
        <Route path="/settings/customers/:uid">
          <CustomersForm />
        </Route>

        <Route path="/settings/operatives">
          <Operatives />
        </Route>
        <Route path="/settings/rates">
          <Rates />
        </Route>
        <Route path="/settings/customers">
          <Customers />
        </Route>
        <Route path="/settings/business-information">
          <BusinessInfo />
        </Route>
        <Route path="/settings/linkedAccounts">
          <LinkedAccounts />
        </Route>
        <Route path="/settings/export">
          <ExportWrapper />
        </Route>
        <Route path="/settings/ai-features">
          <AIFeaturesSettings />
        </Route>
        <Route path="/settings/templates">
          <TemplatesSettings />
        </Route>

        <Route path="/settings">
          <GeneralSettings />
        </Route>

        {/* <Route path="/settings/:uid">
          <SettingsForm />
        </Route> */}
      </Switch>
    </div>
  );
};

export default Settings;
